import { createFileRoute, Link } from "@tanstack/react-router";

import { ErrorState } from "@/components/reusable-components/error-state";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/unauthorized")({
  component: UnauthorizedPage,
});

function UnauthorizedPage() {
  return (
    <ErrorState
      code="401"
      title="Unauthorized Access"
      description={
        <>
          Please log in with the appropriate credentials <br /> to access this
          resource.
        </>
      }
      // The default "Go Back" is useless here: it returns to the route whose
      // guard denied access, which redirects straight back. Offer a sign-in as
      // another user instead.
      action={
        <>
          <Button variant="outline" asChild>
            <Link to="/logout">Log out</Link>
          </Button>
          <Button asChild>
            <Link to="/">Back to Home</Link>
          </Button>
        </>
      }
    />
  );
}
